import React from 'react'
import {Icon} from '@chakra-ui/react'

const ManualsIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_31_644)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.625 32.375V33.875C7.625 34.9582 8.51051 35.8438 9.59375 35.8438H35.375V38.8438H9.59375C6.85366 38.8438 4.625 36.6151 4.625 33.875V32.375H7.625Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.625 7.28125C4.625 3.89366 7.36241 1.15625 10.75 1.15625H32.7188C34.1793 1.15625 35.375 2.35199 35.375 3.8125V29.25C35.375 30.7105 34.1793 31.9062 32.7188 31.9062H9.59375C8.51051 31.9062 7.625 32.7918 7.625 33.875C7.625 34.7034 6.95343 35.375 6.125 35.375C5.29657 35.375 4.625 34.7034 4.625 33.875V7.28125ZM7.625 29.3129C8.22896 29.0513 8.89471 28.9062 9.59375 28.9062H32.375V4.15625H10.75C9.01926 4.15625 7.625 5.55051 7.625 7.28125V29.3129Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.5 11H15.5C14.6716 11 14 11.6716 14 12.5C14 13.3284 14.6716 14 15.5 14H23.5C24.3284 14 25 13.3284 25 12.5C25 11.6716 24.3284 11 23.5 11ZM15.5 8C13.0147 8 11 10.0147 11 12.5C11 14.9853 13.0147 17 15.5 17H23.5C25.9853 17 28 14.9853 28 12.5C28 10.0147 25.9853 8 23.5 8H15.5Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.5625 28.9062C32.3909 28.9062 33.0625 29.5778 33.0625 30.4062V37.3438C33.0625 38.1722 32.3909 38.8438 31.5625 38.8438C30.7341 38.8438 30.0625 38.1722 30.0625 37.3438V30.4062C30.0625 29.5778 30.7341 28.9062 31.5625 28.9062Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_31_644">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000244141)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default ManualsIcon
